import styles from './Layout.module.scss';
import { memo } from 'react';
import { Outlet } from 'react-router';

const Layout = () => (
  <div className={styles.layout}>
    <main>
      <Outlet />
    </main>
  </div>
);

export default memo(Layout);
